import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_GIFTS,
  REQUEST_CREATE_MASTER_GIFTS,
  SET_MASTER_GIFTS,
  SUCCESS_CREATE_MASTER_GIFTS,
  ERROR_GET_MASTER_GIFTS,
  ERROR_CREATE_MASTER_GIFTS,
  SET_MESSAGE_MASTER_GIFTS,
  SUCCESS_DELETE_MASTER_GIFTS,
  SUCCESS_UPDATE_MASTER_GIFTS,
  REQUEST_DELETE_MASTER_GIFTS,
  REQUEST_UPDATE_MASTER_GIFTS,
  ERROR_DELETE_MASTER_GIFTS,
  ERROR_UPDATE_MASTER_GIFTS,
} from "./giftcardsActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterGifts: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterGifts: [],
};

const giftscards = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_GIFTS:
    case REQUEST_CREATE_MASTER_GIFTS:
    case REQUEST_DELETE_MASTER_GIFTS:
    case REQUEST_UPDATE_MASTER_GIFTS:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_GIFTS:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_GIFTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterGifts: action.payload,
      };

    case SUCCESS_CREATE_MASTER_GIFTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterGifts: [...state.masterGifts, action.payload],
      };
    case SUCCESS_DELETE_MASTER_GIFTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterGifts: state.masterGifts.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_GIFTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterGifts: state.masterGifts.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_GIFTS:
    case ERROR_CREATE_MASTER_GIFTS:
    case ERROR_UPDATE_MASTER_GIFTS:
    case ERROR_DELETE_MASTER_GIFTS:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default giftscards;

export function useGiftsMaster() {
  return useSelector((state: Record<string, any>) => state.giftscards);
}
